import { combineReducers } from "redux";

import publicReducer from "./publicReducer/reducer";
import cartReducer from "./cartReducer/reducer";

const rootReducer = (state, action, history) => {
  const allReducers = combineReducers({
    public: publicReducer,
    cart: cartReducer,
  });

  return allReducers(state, action);
};

export default rootReducer;
